import { Row, Col } from 'antd';

import DirectRelations from './direct-relations';
import IndirectRelations from './indirect-relations';

/**
 * @param {Object} props
 * @param {string} props.baseType - Encyclopedia type of the base article (e.g. 'article', 'term').
 * @param {number|string} props.baseId - ID of the base article.
 */
function ArticleRelations({ baseType, baseId }) {
  return (
    <Row gutter={24} className="gx-mt-3">
      <Col span={12}>
        <DirectRelations baseType={baseType} baseId={baseId} />
      </Col>
      <Col span={12}>
        <IndirectRelations baseType={baseType} baseId={baseId} />
      </Col>
    </Row>
  );
}

export default ArticleRelations;
